import { TEXTURE_WARP } from 'src/models/documentWarps';

/**
 * Finishes/color-profile concepts don't apply to texture warps (see FinishSelector's own gating in
 * layer/information/index.tsx), so the print-white hint is hidden there too.
 */
export function resolvePrintWhiteForHint(warpType: string | undefined, printWhite: boolean | null): boolean | null {
    return warpType === TEXTURE_WARP ? null : printWhite;
}
